var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagramCircle = function SvgInstagramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20Zm0-2c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18Zm-9.09-23.577a3.518 3.518 0 0 1 3.513-3.514h11.154a3.518 3.518 0 0 1 3.514 3.514v11.154a3.518 3.518 0 0 1-3.514 3.514H14.423a3.518 3.518 0 0 1-3.514-3.514V14.423Zm16.077-1.42-.402.002-2.681.008.01 3.082 3.073-.01v-3.082ZM20 16.8a3.196 3.196 0 0 0-2.595 1.335A3.186 3.186 0 0 0 16.8 20c0 1.764 1.436 3.2 3.2 3.2 1.765 0 3.2-1.436 3.2-3.2a3.18 3.18 0 0 0-.605-1.866A3.196 3.196 0 0 0 20 16.799Zm5.577 10.52c.961 0 1.742-.78 1.742-1.742v-7.444h-2.714c.233.578.367 1.207.367 1.867A4.978 4.978 0 0 1 20 24.972 4.977 4.977 0 0 1 15.03 20c0-.66.13-1.29.366-1.866H12.68v7.443c0 .961.782 1.742 1.743 1.742h11.154Z",
    fill: "#007A43"
  })));
};

export default SvgInstagramCircle;